<template>
  <div :class="$style[classes]">
    <pt-page-title title="下载表格"></pt-page-title>
    <pt-page-factor-filter :labels="filterLabels" labelWidth="100px" v-model="filterForm" ref="filter">
    </pt-page-factor-filter>
    <el-button type="primary" @click="downloadInOutTable()">下载出入库记录表</el-button>
    <el-button type="primary" @click="downloadMRTable()">下载核磁表格</el-button>
    <el-button type="primary" @click="downloadMRHistory()">核磁表格下载历史</el-button>
    <el-button type="primary" @click="downloadInOutHistory()">出入库记录表下载历史</el-button>
  </div>
</template>

<script>
// 组件class前缀
const prefixCls = 'pt-download-the-form'
import { filterLabels } from "./options"

export default {
  name: 'pt-download-the-form',
  computed: {
    classes () {
      return `${prefixCls}`
    }
  },
  data () {
    return {
      filterLabels,
      filterForm:{}
    }
  },
  methods: {
    downloadInOutTable () {
      if (this.filterFormat()) {
        this.$emit('getInOutTableDownload',this.filterForm)
      }
    },
    filterFormat () {
      if (this.filterForm.createdDateStart > this.filterForm.createdDateEnd) {
        this.$message.error('开始时间不能大于结束时间')
        return false
      }
      return true
    },
    downloadMRTable () {
      if (this.filterFormat()) {
        this.$emit('getMrTableDownload', this.filterForm)
      }
      // this.$router.push('/export-history/bills_download?name=lab_bill_mr_table_download&isDownload=true')
    },
    downloadMRHistory () {
      this.$router.push('/export-history/table_download_MR?name=lab_bill_item_mr&isDownload=true')
    },
    downloadInOutHistory () {
      this.$router.push('/export-history/table_download_in_out?name=lab_bill_in_out_record&isDownload=true')
    }
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
.pt-download-the-form{
  :global{
  .el-button{
    margin-right: 20px;
    margin-left: 0!important;
  }
  }
}
</style>
